import React from "react";
import { TowerControl } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { updateField } from "../../../../redux/slices/employee-slice";

const Identities = () => {
  const dispatch = useDispatch();
  const form = useSelector((state) => state.employeeForm);
  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(updateField({ name, value }));
  };

  return (
    <>
      <div className="flex items-start justify-between bg-white px-4 mt-6">
        <div className="flex flex-col gap-3 mt-8">
          <TowerControl className="h-7 w-7 text-active-color stroke-1" />
          <h4 className="font-semibold text-md">Identities</h4>
          <p className="text-gray-400 text-md -mt-2">
            Fill in the employee's Identities.
          </p>
        </div>
        <div className="bg-form-bg w-lg rounded-md px-4 grid grid-cols-12 gap-6 py-8 mr-8">
          <div className="col-span-6 flex flex-col gap-6">
            
            <div className="flex flex-col gap-1">
              <div className="flex items-center justify-between">
                <label htmlFor="id" className="text-md ">
                  National ID
                </label>
              </div>
              <input
                type="text"
                placeholder="National ID"
                className="border px-2 py-1 rounded-md border-secondary outline-hidden text-md bg-white"
                name="nationalId"
                onChange={handleChange}
                value={form.nationalId}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label htmlFor="id" className="text-md">
                EOBI No
              </label>
              <input
                type="text"
                placeholder="EOBI No"
                className="border px-2 py-1 rounded-md border-secondary outline-hidden text-md bg-white"
                name="EQBI"
                onChange={handleChange}
                value={form.EQBI}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label htmlFor="id" className="text-md">
                NTN No..
              </label>
              <input
                type="text"
                placeholder="NTN No"
                className="border px-2 py-1 rounded-md border-secondary outline-hidden text-md bg-white"
                name="NTN"
                onChange={handleChange}
                value={form.NTN}
              />
            </div>
          </div>
          {/* second col */}
          <div className="col-span-6 flex flex-col gap-6">
          <div className="flex flex-col gap-1">
              <label htmlFor="id" className="text-md">
                Employee Code
                <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
              </label>
              <input
                type="text"
                placeholder=""
                className="border px-2 py-1 rounded-md border-secondary outline-hidden text-md bg-white"
                name="employee_code"
                onChange={handleChange}
                value={form.employee_code}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label htmlFor="id" className="text-md">
                Attendance Machine Code
              </label>
              <input
                type="text"
                placeholder=""
                className="border px-2 py-1 rounded-md border-secondary outline-hidden text-md bg-white"
                name="machineCode"
                onChange={handleChange}
                value={form.machineCode}
              />
            </div>
            <div className="flex flex-col gap-1">
              <div className="flex items-center justify-between">
                <label htmlFor="id" className="text-md">
                  Passport No
                </label>
                {/* <span
                  className="text-[8px] px-2 py-0.5 bg-secondary rounded-sm text-black cursor-pointer hover:bg-active-color hover:text-white"
                  onClick={() => setPassportExpiry(true)}
                >
                  Add Expiry
                </span> */}
              </div>
              <input
                type="text"
                placeholder="Passport No."
                className="border px-2 py-1 rounded-md border-secondary outline-hidden text-md bg-white"
                name="passportNo"
                onChange={handleChange}
                value={form.passportNo}
              />
            </div>
            
          </div>
        </div>
      </div>
    </>
  );
};

export default Identities;
